import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Card, Divider, Flex, Tag, Tooltip, Typography } from 'antd';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import type { CardItemProps } from '@app/components/RecordModal/components/RecordPayment/types';
import {
  PayWithBonusesModal,
  ApplyPercentageDiscount,
} from '@app/components/RecordModal/components/RecordPayment/ui';

const { Text } = Typography;

export const CardItem: React.FC<CardItemProps> = ({
  card,
  recordId,
  servicesTableData,
  bonusesToExceed,
  getRecordInfoHandler,
  totalPaid,
  appliedCardId,
  initTable,
  fetchPayments,
}) => {
  const [isPayWithBonusesModalOpen, setIsPayWithBonusesModalOpen] =
    useState(false);
  const [
    isApplyPercentageDiscountModalOpen,
    setIsApplyPercentageDiscountModalOpen,
  ] = useState(false);

  const handlePayWithBonusesModalOpen = () => {
    setIsPayWithBonusesModalOpen(true);
  };

  const handleApplyPercentageDiscountModalOpen = () => {
    setIsApplyPercentageDiscountModalOpen(true);
  };

  return (
    <Card>
      <Flex gap={10}>
        <Flex vertical gap={10}>
          <Flex justify="space-between" gap={16}>
            <Text strong>Карта лояльности</Text>{' '}
            <Text strong>{card.number}</Text>
            <Link
              to={{
                pathname: '/cards',
                search: `?redirectTo=${encodeURIComponent(
                  `cards?serial=${card.id}&modal=card-info-modal`
                )}`,
              }}
              target="_blank"
            >
              <Tooltip title="Для отображения информации по карте нажмите на эту иконку">
                <InfoCircleOutlined />
              </Tooltip>
            </Link>
          </Flex>

          <Flex justify="space-between" gap={16}>
            <Text>{card.name}</Text>
            <Tag color="silver">{card.level}</Tag>
          </Flex>

          <Flex justify="space-between" gap={16}>
            <Text>Дата выдачи:</Text>{' '}
            <Text>{dayjs(card.created_at).format('DD.MM.YYYY')}</Text>
          </Flex>
        </Flex>

        <Divider type="vertical" className="data-divider" />

        {card.type === 'bonus' && (
          <Flex vertical gap={10}>
            <Text>Баланс</Text>
            <Text strong>{card.bonuses} бонусов</Text>
            {servicesTableData.length > 0 && card.bonuses > 0 && (
              <Button
                type="default"
                size="small"
                color="primary"
                variant="outlined"
                onClick={handlePayWithBonusesModalOpen}
                disabled={totalPaid > 0}
              >
                Списать
              </Button>
            )}
          </Flex>
        )}
        {card.type === 'discount' && (
          <Flex vertical gap={10}>
            <Text>Величина скидки</Text>
            <Text strong>{card.discount} процентов</Text>
            {!appliedCardId && servicesTableData.length > 0 && (
              <Button
                type="default"
                size="small"
                color="primary"
                variant="outlined"
                onClick={handleApplyPercentageDiscountModalOpen}
                disabled={totalPaid > 0}
              >
                Применить
              </Button>
            )}
          </Flex>
        )}
      </Flex>

      <PayWithBonusesModal
        isOpen={isPayWithBonusesModalOpen}
        setIsOpen={setIsPayWithBonusesModalOpen}
        availableBonuses={card.bonuses}
        cardId={card.id}
        cardNumber={card.number}
        recordId={recordId}
        servicesTableData={servicesTableData}
        bonusesToExceed={bonusesToExceed}
        getRecordInfoHandler={getRecordInfoHandler}
        initTable={initTable}
        fetchPayments={fetchPayments}
      />

      <ApplyPercentageDiscount
        isOpen={isApplyPercentageDiscountModalOpen}
        setIsOpen={setIsApplyPercentageDiscountModalOpen}
        percentageDiscount={card.discount}
        cardId={card.id}
        cardNumber={card.number}
        recordId={recordId}
        initTable={initTable}
        getRecordInfoHandler={getRecordInfoHandler}
        fetchPayments={fetchPayments}
      />
    </Card>
  );
};
